import { SurfaceContext } from '#pplx/frontend/aether/components/Surface/SurfaceContext.js';
import { useActivationOrderedOverlayStacking } from '#pplx/frontend/overlay-stacking/useOverlayStacking.js';
import { useContext } from 'react';
/** Returns nearest Surface portal target, or null without ancestor Surface. */
export function useNearestSurface() {
    const shouldUseActivationOrder = useActivationOrderedOverlayStacking();
    const { portalTargetElement } = useContext(SurfaceContext);
    return shouldUseActivationOrder ? null : portalTargetElement;
}
/** Returns elevation tier of nearest ancestor Surface. */
export function useElevation() {
    const shouldUseActivationOrder = useActivationOrderedOverlayStacking();
    const { elevation } = useContext(SurfaceContext);
    return shouldUseActivationOrder ? undefined : elevation;
}
//# sourceMappingURL=useSurface.js.map